<template>
  <div>
    <vs-popup title="Adicionar Categoria" :active.sync="addGroupPopupActive" class="sizePopup">
      <table-category-of-customer
        :groups="groupsOfCustomerAvailable"
        @saveGroupsOnCustomer="attachGroupsOnCustomer"
        :addGroupPopupActive="addGroupPopupActive"
      />
    </vs-popup>

    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isSidebarActiveLocal"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ this.customer.id === null ? "ADICIONAR NOVO" : "ATUALIZAR" }} CONTATO</h4>
        <feather-icon
          icon="XIcon"
          @click.stop="isSidebarActiveLocal = false"
          class="cursor-pointer"
        />
      </div>
      <vs-divider class="mb-0"/>

      <VuePerfectScrollbar
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >

        <div class="p-6">
          <!-- Access Token -->
          <vs-input
            label="Nome"
            v-model="customer.name"
            class="mt-5 w-full"
            name="nome"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('nome')"
          >
            {{ errors.first('nome') }}
          </span>

          <vx-input-phone
            label="Número de Telefone"
            class="mt-5 w-full"
            name="telefone"
            v-model="customer.phone_number"
            :reload="isSidebarActiveLocal"
            :preferredCountries="['BR']"
            @update="setInternational"
            v-validate="'required'"
          />

          <span
            class="text-danger text-sm"
            v-show="errors.has('telefone')"
          >
            {{ errors.first('telefone') }}
          </span>

          <vs-input
            v-if="hasEmailFeature"
            label="Endereço de Email (Opcional)"
            v-model="customer.email"
            class="mt-5 w-full"
            name="email"
          />

          <div class="w-full mt-5 mb-5">
            <label for class="vs-input--label">Informações</label>
            <vs-textarea v-model="customer.open_field" />
          </div>
            <div class="flex flex-col">
              <div v-if="canSee('favorit')" class="w-full flex items-center mb-2">
                <vs-checkbox v-model="customer.is_favorite"></vs-checkbox>
                <label for class="vs-input--label">Favorito WhatsApp</label>
              </div>

              <div class="w-full flex items-center mb-2">
                <vs-checkbox v-model="customer.is_blacklisted"></vs-checkbox>
                <label for class="vs-input--label">Bloqueado da Campanha WhatsApp</label>
              </div>

              <div class="w-full flex items-center mb-2" v-if="hasSmsFeature">
                <vs-checkbox v-model="customer.is_blacklisted_sms"></vs-checkbox>
                <label for class="vs-input--label">Bloqueado da Campanha Sms</label>
              </div>

              <div class="w-full flex items-center mb-2" v-if="hasEmailFeature">
                <vs-checkbox v-model="customer.is_blacklisted_email"></vs-checkbox>
                <label for class="vs-input--label">Bloqueado da Campanha E-mail</label>
              </div>
            </div>

          <div class="w-full mt-5 mb-5">
            <h3>Categoria do Contato</h3>

            <p v-if="!customerGroups.length" class="mt-2">Nenhuma categoria vinculada.</p>

            <vs-chip
              :key="`customer-group-${index}`"
              @click="removeGroup(customerGroup)"
              v-for="(customerGroup, index) in customerGroups"
              closable
              :color="customerGroup.group.color_tag"
              class="mt-3 mr-3"
              style="font-size: 0.9rem;"
            >
              {{ customerGroup.group.name }}
            </vs-chip>

            <vs-chip
              @click="addGroups"
              closable
              close-icon="add"
              class="mt-3 mr-3"
              style="font-size: 0.9rem;"
            >
              Adicionar Categoria
            </vs-chip>
          </div>
        </div>
      </VuePerfectScrollbar>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">
          Salvar
        </vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">
          Cancelar
        </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import TableCategoryOfCustomer from './TableCategoryOfCustomer'

import moduleCustomer from '@/store/customer/moduleCustomer'
import moduleCustomerGroup from '@/store/customerGroup/moduleCustomerGroup'

import { hasPermission, encodeToBase64, hasFeature } from '@/utils'
import VxInputPhone from "@/components/vx-input-phone/index.vue";

export default {
  name: 'customer-view-sidebar',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    customer: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          name: '',
          phone_number: '',
          international_phone_number: '',
          email: '',
          is_blacklisted: false,
          is_favorite: false,
          open_field: '',
          hasSmsFeature: false,
          hasEmailFeature: false,
          is_blacklisted_sms: false,
          is_blacklisted_email: false
        }
      }
    }
  },
  data() {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      customerGroups: [],
      addGroupPopupActive: false,
      groupsOfCustomerAvailable: []
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.initValues();
          this.$emit('closeSidebar');
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    }
  },
  methods: {
    canSee(action) {
      return hasPermission(`${this.$route.name}-${action}`)
    },
    setInternational(phone){
      if (phone && phone.e164){
        this.customer.international_phone_number = phone.e164.replace('+', '')
      }
    },
    initValues() {
      this.customer = {
        id: null,
        name: '',
        phone_number: '',
        international_phone_number: '',
        email: '',
        is_blacklisted: false,
        is_favorite: false,
        open_field: '',
        hasEmailFeature: false,
        hasSmsFeature: false,
        is_blacklisted_sms: false,
        is_blacklisted_email: false
      }

      this.errors.clear();
      this.$validator.reset();
    },
    addGroups() {
      this.addGroupPopupActive = true
    },
    attachGroupsOnCustomer(selectedGroups) {
      this.addGroupPopupActive = false
      this.customerGroups = [
        ...this.customerGroups,
        ...selectedGroups
      ]
    },
    removeGroup (group) {
      if (group.id) {
        this.$store.dispatch("customerGroup/deleteCustomerGroup", group.id).then(() => {
          this.customerGroups.splice(this.customerGroups.indexOf(group), 1)
        }).catch(err => {
          console.error(err)
        })
      } else {
        this.customerGroups.splice(this.customerGroups.indexOf(group), 1)
      }
    },
    submitData() {
      const that = this
      const chosenGroups = this.customerGroups.map(({ group }) => group.id)

      this.$validator.validateAll().then(result => {
        if (result) {
          const customerData = this.$_.cloneDeep(this.customer)

          if (customerData.open_field !== null) {
            customerData.open_field = encodeToBase64(customerData.open_field);
          }

          if (customerData.international_phone_number != null) {
            customerData.phone_number = customerData.international_phone_number;
            delete customerData.international_phone_number;
          }

          customerData.is_blacklisted = Number(customerData.is_blacklisted);
          customerData.is_blacklisted_sms = Number(customerData.is_blacklisted_sms);
          customerData.is_blacklisted_email = Number(customerData.is_blacklisted_email);
          customerData.is_favorite = Number(customerData.is_favorite);

          if (customerData.open_field === '' || customerData.open_field === null) {
            customerData.open_field = ' ';
          }

          if (this.customer.id !== null && this.customer.id >= 0) {
            this.$store.dispatch("customer/update", { customer: customerData, chosenGroups }).then(() => {
              that.initValues()
              this.$emit('closeSidebar')
              this.$emit('fetchCustomers')
              this.$vs.notify({
                title: "Sucesso",
                text: "Contato atualizado com sucesso",
                color: "success",
              });
            }).catch(err => {
              console.error(err)
            })
          } else {
            delete this.customer.id
            this.$store.dispatch("customer/add", { customer: customerData, chosenGroups }).then(() => {
              that.initValues()
              this.$emit('closeSidebar')
              this.$emit('fetchCustomers')
              this.$vs.notify({
                title: "Sucesso",
                text: "Contato adicionado com sucesso",
                color: "success",
              });
            }).catch(err => {
              console.error(err)
            })
          }
        }
      })
    }
  },
  created() {
    if (!moduleCustomer.isRegistered) {
      this.$store.registerModule('customer', moduleCustomer)
      moduleCustomer.isRegistered = true
    }

    if (!moduleCustomerGroup.isRegistered) {
      this.$store.registerModule('customerGroup', moduleCustomerGroup)
      moduleCustomerGroup.isRegistered = true
    }
  },
  async mounted(){
    this.hasSmsFeature = await hasFeature('sms')
    this.hasEmailFeature = await hasFeature('email')
  },
  watch: {
    customer: function () {
      if (this.customer.id) {
        this.$store.dispatch("customerGroup/fetchCustomerGroups", this.customer.id).then(res => {
          this.customerGroups = res.data.data.customerGroups
        }).catch(err => {
          console.error(err)
        })
      } else {
        this.customerGroups = []
      }
    },
    addGroupPopupActive: function (val) {
      if (val) {
        const removeIds = this.customerGroups.map(cg => cg.group.id)

        this.$store.dispatch("customerGroup/fetchDiffGroupsOfCustomer", removeIds).then(res => {
          const { groupsOfCustomer } = res.data.data 
          this.groupsOfCustomerAvailable = groupsOfCustomer.map(group => ({
            id: null,
            group
          }))
        }).catch(err => {
          console.error(err)
        })
      }
    }
  },
  components: {
    VxInputPhone,
    VuePerfectScrollbar,
    TableCategoryOfCustomer
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>